import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { axiosPrivate, axiosQuick } from "../api/axios";
import { categoryList } from "../data/categories";
import { useNavigate } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import { ProgressBar } from "primereact/progressbar";
import { Grid, TextField, Button } from "@mui/material";
import { Dropdown } from "primereact/dropdown";
import loader from "../utils/Helper";
import moment from "moment";
import { InputSwitch } from 'primereact/inputswitch';

const CREATE_QUERY_URL = "/createQuery";
const GET_ALL_CUST = "/getAllCustomers";
const CreateQuery = ({ isSuperAdmin=false, isAdmin=false,loggedinuserid, fileITR }) => {
  const [loading, setLoading] = useState(false);
  const [financialYearOptions, setFinancialYearOptions] = useState([]);
  const [UserList, setUserList] = useState([]);
  const itrCategory = [
    {
      id: 1,
      category: "Income Tax Act, 1961",
    },
  ];
  const navigate = useNavigate();
  let fileDatta = [];
  const getBase64 = (fileData) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
        fileDatta.push({
          fileBase64: reader.result,
          fileName: fileData.name,
        });
        formik.setFieldValue("file", fileDatta);
      };
    });
  };
  const fileHandle = async (event) => {
    const fileData = [...event.target.files];
    fileData.map((singleFile) => {
      getBase64(singleFile);
    });
  };

  const formik = useFormik({
    initialValues: {
      category: fileITR ? itrCategory[0] : null,
      financialYear: null,
      subject: "",
      assesseeName: "",
      referredBy: "",
      message: "",
      dueDate: null,
      file: [],
      selectedcustomer: null,
      isAdmin: isAdmin,
      isSuperAdmin:isSuperAdmin,
    },
    validateOnBlur: true, // Disable onBlur validation
    validateOnChange: true, // Disable onChange validation
    onSubmit: async (values) => {
      try {
        setLoading(true);
        loader.isLoading(true);
        let userData = isAdmin || isSuperAdmin
          ? values.selectedcustomer
          : JSON.parse(localStorage.getItem("user"));
        const token = JSON.parse(localStorage.getItem("user"));
        let request = {
          createdBy : loggedinuserid,
          usersId: userData.id,
          categoryId: values.category?.id,
          isAdmin: isAdmin,
          isSuperAdmin:isSuperAdmin,
          subject: values.subject,
          assesseeName : values.assesseeName,
          referredBy : values.referredBy,
          financialYear: values.financialYear?.year || null,
          dueDate: values.dueDate ? moment.utc(values.dueDate) : null,
          blockAssessment : values.blockAssessment,
          start: values.blockAssessment ? (values.start ? moment.utc(values.start) : null) : null,
          end: values.blockAssessment ? (values.end ? moment.utc(values.end) : null) : null,
          comments: [
            {
              userId: userData.id,
              comment: values?.message,
              created: new Date().toString().split(" GMT")[0],
            },
          ],
          documents: values.file,
        };

        const response = await axiosPrivate.post(CREATE_QUERY_URL, request, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.jwtToken}`,
          },
        });
        setLoading(false);
        loader.isLoading(false);
        if (response.status === 200) {
          navigate(`/query-details/${response.data.queryId}`);
        }
      } catch (err) {
        setLoading(false);
        loader.isLoading(false);
        console.log(err);
      }
    },
    validate: (values) => {
      const errors = {};

      if (!values.category) {
        errors.category = " Please select a department";
      }

      if (!values.subject) {
        errors.subject = "Please enter a subject";
      }

      if (!values.message) {
        errors.message =
          "Please describe the issue in detail ";
      }

      // if (!values.dueDate) {
      //   errors.dueDate = "Please select a due date";
      // }
      if(values.category && values.category?.id==1 && !values.financialYear){
        errors.financialYear = "Please select a financial year";
      }
      if (!values.selectedcustomer && (isAdmin || isSuperAdmin)) {
        errors.selectedcustomer = "Please select user";
      }

     if (values.blockAssessment) {
        if (!values.start) {
          errors.start = "Please select a start date";
        }

        if (!values.end) {
          errors.end = "Please select an end date";
        }

        if (values.start && values.end && values.start > values.end) {
          errors.start = "Start date cannot be greater than end date";
        }
      }
      console.log("error", errors, values);
      return errors;
    },
  });
  const getCustomers = async () => {
    try {
      setLoading(true);
      const userData = JSON.parse(localStorage.getItem("user"));

      loader.isLoading(true);
      const response = await axiosQuick.get(`${GET_ALL_CUST}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.jwtToken}`,
        },
      });

      if (response.status == 200) {
        setUserList(response.data);
      } else {
        setUserList([]);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      loader.isLoading(false);
    }
  };

  useEffect(() => {
    if (!financialYearOptions.length) {
      var currentYear = new Date().getFullYear() + 1;
      const fyOptions = [];
      for (let i = currentYear; i >= 2001; i--) {
        var op = {
          id: parseInt(i) - 1 + "-" + i,
          year: parseInt(i) - 1 + "-" + i,
        };
        fyOptions.push(op);
      }
      setFinancialYearOptions(fyOptions);
    }
    if (isAdmin || isSuperAdmin) {
      getCustomers();
    }
  }, []);

  return (
    <div className="container">
      <form className="form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={3}>
          <Grid>userData</Grid>
          {(isAdmin || isSuperAdmin) && (
            <Grid item xs={12}>
              <div className="form-group d-flex flex-column-reverse position-relative">
                {formik.touched.selectedcustomer && (
                  <span className="text-danger">
                    {formik.errors.selectedcustomer}
                  </span>
                )}

                <Dropdown
                  autoFocus
                  value={formik.values.selectedcustomer}
                  filter
                  resetFilterOnHide
                  disabled={loading}
                  showClear
                  filterPlaceholder="Search Users"
                  options={UserList}
                  onChange={(e) =>{
                   
                    formik.setFieldValue("selectedcustomer", e.value)
                  }
                   
                  }
                  optionLabel={(customer) =>
                    `${customer.referenceName || "Name Not Defined"}  -   ${
                      customer.username || ""
                    } - ${customer.email}`
                  }
                  style={{ width: "100%" }}
                  placeholder="Select a User"
                  id="User"
                />

                <label htmlFor="User">User</label>
              </div>
            </Grid>
          )}
          <Grid item xs={12}>
            <div className="form-group d-flex flex-column-reverse position-relative">
              {formik.touched.category && (
                <span className="text-danger">{formik.errors.category}</span>
              )}
              {!fileITR ? (
                <Dropdown
                  value={formik.values.category}
                  options={categoryList}
                  onChange={(e) => formik.setFieldValue("category", e.value)}
                  optionLabel="category"
                  style={{ width: "100%" }}
                  disabled={loading}
                  placeholder="Select a Department"
                  id="issue_categories"
                  filter
                  resetFilterOnHide
                  filterPlaceholder="Search Department"
                />
              ) : (
                <Dropdown
                  value={formik.values.category}
                  disabled={true}
                  options={itrCategory}
                  style={{ width: "100%" }}
                  optionLabel="category"
                  filter
                  filterPlaceholder="Search Department"
                  resetFilterOnHide
                  placeholder="Select a Department"
                  id="issue_categories"
                />
              )}
              <label htmlFor="issue_categories">Category</label>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group d-flex flex-column-reverse position-relative">
              {formik.touched.financialYear && (
                <span className="text-danger">
                  {formik.errors.financialYear}
                </span>
              )}
              <Dropdown
                style={{ width: "100%" }}
                value={formik.values.financialYear}
                options={financialYearOptions}
                disabled={loading}
                optionLabel="year"
                filter
                resetFilterOnHide
                filterPlaceholder="Search financial year"
                onChange={(e) => formik.setFieldValue("financialYear", e.value)}
                showClear
                placeholder="Select a financial year"
              />
              <label htmlFor="Financial Year">Financial Year</label>
            </div>
          </Grid>

          <Grid item xs={12}>
            <div
              className="form-group d-flex align-items-center"
              style={{ gap: "12px" }}
            >
              <label htmlFor="blockAssessment" className="mb-0">
                Block Assessment
              </label>

              <InputSwitch
              style={{top:"19px"}}
                inputId="blockAssessment"
                checked={formik.values.blockAssessment}
                onChange={(e) =>
                  formik.setFieldValue("blockAssessment", e.value)
                }
              />
            </div>
          </Grid>

          {formik.values.blockAssessment &&
           <Grid item xs={12}>
            <div className="form-group d-flex flex-column-reverse position-relative">
           {(formik.touched.start || formik.submitCount > 0) &&
            formik.errors.start && (
              <span className="text-danger">{formik.errors.start}</span>
          )}

             <Calendar
              id="start"
              dateFormat="mm-dd-yy"
              disabled={loading}
              value={formik.values.start}
              onChange={(e) => formik.setFieldValue("start", e.value)}
              onBlur={() => formik.setFieldTouched("start", true)}
            />
              <label htmlFor="duedate">Start Date</label>
            </div>
          </Grid>
          }

          {formik.values.blockAssessment &&
           <Grid item xs={12}>
            <div className="form-group d-flex flex-column-reverse position-relative">
              {(formik.touched.end || formik.submitCount > 0) &&
                formik.errors.end && (
                  <span className="text-danger">{formik.errors.end}</span>
              )}

              <Calendar
                id="end"
                dateFormat="mm-dd-yy"
                disabled={loading}
                value={formik.values.end}
                onChange={(e) => formik.setFieldValue("end", e.value)}
              />
              <label htmlFor="end">End Date</label>
            </div>
          </Grid>
          }

          <Grid item xs={12}>
            <div className="form-group d-flex flex-column-reverse position-relative">
              {formik.touched.assesseeName && (
                <span className="text-danger">{formik.errors.assesseeName}</span>
              )}
              <TextField
                id="assesseeName"
                className="custom-inputField"
                disabled={loading}
                style={{ height: "50px" }}
                fullWidth
                {...formik.getFieldProps("assesseeName")}
              />

              <label htmlFor="assesseeName">Assessee name</label>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group d-flex flex-column-reverse position-relative">
              {formik.touched.referredBy && (
                <span className="text-danger">{formik.errors.referredBy}</span>
              )}
              <TextField
                id="referredBy"
                className="custom-inputField"
                disabled={loading}
                // style={{ height: "50px" }}
                fullWidth
                multiline
                rows={4}
                {...formik.getFieldProps("referredBy")}
              />

              <label htmlFor="referredBy">Referred by</label>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group d-flex flex-column-reverse position-relative">
              {formik.touched.subject && (
                <span className="text-danger">{formik.errors.subject}</span>
              )}
              <TextField
                id="subject"
                className="custom-inputField"
                disabled={loading}
                style={{ height: "50px" }}
                fullWidth
                {...formik.getFieldProps("subject")}
              />

              <label htmlFor="subject">Subject</label>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group d-flex flex-column-reverse position-relative">
              {formik.touched.message && (
                <span className="text-danger">{formik.errors.message}</span>
              )}

              <TextField
                id="message"
                disabled={loading}
                fullWidth
                multiline
                rows={6}
                {...formik.getFieldProps("message")}
              />
              <label htmlFor="message">Describe the issue in detail</label>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group d-flex flex-column-reverse position-relative">
              {formik.touched.dueDate && (
                <span className="text-danger">{formik.errors.dueDate}</span>
              )}

              <Calendar
                id="dueDate"
                dateFormat="mm-dd-yy"
                disabled={loading}
                value={formik.values.dueDate}
                onChange={(e) => formik.setFieldValue("dueDate", e.value)}
              />
              <label htmlFor="duedate">Due Date</label>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="form-group d-flex flex-column-reverse position-relative">
              <input
                disabled={loading}
                type="file"
                style={{ width: "100%", height: "50px", padding: "10px" }}
                id="file"
                onChange={fileHandle}
                className="form-control"
                autoComplete="off"
                multiple
              />
              <label htmlFor="file">Supporting Documents</label>
            </div>
          </Grid>
          <Grid item xs={12}>
            {loading && (
              <ProgressBar
                mode="indeterminate"
                style={{ height: "6px" }}
              ></ProgressBar>
            )}
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              className={
                loading
                  ? "btn btn-primary btn-h float-right disabled submitbutton"
                  : "btn btn-primary btn-h float-right submitbutton"
              }
              type="submit"
              disabled={loading}
            >
              {!loading
                ? fileITR
                  ? "File ITR"
                  : "Create Query"
                : "Please wait.."}
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default CreateQuery;
